import { useTranslation } from 'react-i18next';

import PermissionSection from 'components/permission/PermissionSection';
import { ConnectorTypes, Permissions } from 'entities/dashboard';
import { useAppSelector } from 'hooks';

import BankAccountInfoModal from './BankAccounts/components/BankAccountInfoModal';
import FundingAccountModal from './BankAccounts/components/FundingAccountModal';
import ApiAccountingModal from './AccountingSoftware/ApiAccountingModal';
import AccountingModal from './AccountingSoftware/AccountingModal';
import { getBankAccountsLength } from './BankAccounts/selectors';
import BankAccountList from './BankAccounts/BankAccountList';
import ConnectorWrapper from './Connectors/ConnectorWrapper';
import OnboardingTabHeader from './OnboardingTabHeader';
import DataSource from './Connectors/DataSource';
import FXProvider from './FXProvider/FXProvider';

const IntegrationTab = () => {
  const { t } = useTranslation('integration');

  const bankAccounts: number = useAppSelector(getBankAccountsLength);

  return (
    <div>
      <OnboardingTabHeader
        title={t('integration:title')}
        subTitle={t('integration:description')}
      />

      <div className="p-6">
        <DataSource />
        <PermissionSection permission={Permissions.erpIntegration}>
          <>
            <AccountingModal />
            <ApiAccountingModal />
          </>
        </PermissionSection>

        <ConnectorWrapper type={ConnectorTypes.bank} isEmpty={!bankAccounts}>
          <BankAccountList />
        </ConnectorWrapper>

        <PermissionSection permission={Permissions.bankIntegration}>
          <>
            <FundingAccountModal />
            <BankAccountInfoModal />
          </>
        </PermissionSection>

        <FXProvider />
      </div>
    </div>
  );
};

export default IntegrationTab;
